/* Wrap spin.js in Backbone View

    Example Use: 
        this.spinner = new Spinner();
        this.ui.spinHolder.append( this.spinner.render().el );
*/

var Marionette = require('marionette'),
    Spinner = require('spin.js');

module.exports = Marionette.ItemView.extend({

    className: 'FV-spinner',

    // Settings for spin.js
    settings: {
        hwaccel: true,
        length: 4,
        radius: 4,
        width: 2
    },

    startHidden: false, // If extend can overwrite on extended classes' prototype

    spinner: {},

    initialize: function( options, startHidden ) {

        this.settings = _.extend({}, this.settings, options); //don't override the proto!

        if ( startHidden )
            this.startHidden = true;

    },

    render: function() {

        this.$el.css('position', 'relative');

        this.spinner = new Spinner(this.settings).spin( this.el );

        this.startHidden && this.triggerMethod('stop'); //way to work with, with immediate rendering

        this.triggerMethod('afterRender');

        return this;

    },
    /* hooks to stop and start without render then destroy */
    onStart: function() {
        this.spinner.spin( this.el );
    },
    onStop: function() {
        this.spinner.stop();
    },
    onBeforeDestroy: function() {
        this.spinner.stop();
    },
    isSpinning: function() {
        return this.spinner.el !== undefined;
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/common/spinView.js
 ** module id = 159
 ** module chunks = 0
 **/